import { compose } from 'recompose'; // lodash

import _head from 'lodash/head';
import _castArray from 'lodash/castArray';
var getArraySafeValue = compose(_head, _castArray);
export default getArraySafeValue;